import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js/auto"
import "chartjs-adapter-date-fns"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object }

  connect() {
    const palette = [
      "rgba(156, 163, 175, 0.7)",
      "rgba(59, 130, 246, 0.7)",
      "rgba(16, 185, 129, 0.7)",
      "rgba(249, 115, 22, 0.7)",
      "rgba(239, 68, 68, 0.7)"
    ]

    const allViews = this.dataValue.datasets.flatMap(ds => ds.data.map(d => d.y))
    const maxViews = Math.max(...allViews, 1)

    const datasets = this.dataValue.datasets.map((ds, i) => ({
      label: ds.label,
      data: ds.data.map(d => ({ x: d.x + "T00:00:00Z", y: d.r, r: Math.max(Math.sqrt(d.y / maxViews) * 40, 4), views: d.y })),
      backgroundColor: palette[i % palette.length]
    }))

    new Chart(this.canvasTarget, {
      type: "bubble",
      data: { datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: { bottom: 20 } },
        scales: {
          x: {
            type: "time",
            time: { unit: "week", tooltipFormat: "MMM d", displayFormats: { week: "MMM d" } },
            title: { display: true, text: "Week" }
          },
          y: {
            beginAtZero: true,
            title: { display: true, text: "Posts" },
            ticks: { stepSize: 1 }
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const raw = ctx.raw
                return `${ctx.dataset.label}: ${raw.views.toLocaleString()} views (${raw.y} posts)`
              }
            }
          }
        }
      }
    })
  }
}
